module.exports = __webpack_public_path__ + "static/img/bg_item_1.5d5c3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_1.png
// module id = vK/n
// module chunks = 1